<template>
  <div style="padding:10px 10px 10px 10px;">
    <div v-for="item in qrs" :key="item.qrid">
      <el-row>
        <el-row>
          <div @click="clickQr(item)">
          <qrItem :qr="item"></qrItem>
          </div>
        </el-row>
      </el-row>
    </div>
  <el-pagination @current-change="handleCurrentChange" :current-page="page"  :page-size="5" layout="total, prev, pager, next, jumper" :total="totalElements">
  </el-pagination>
  </div>
</template>

 <script type="text/javascript" scoped>
import qrItem from './qrItem.vue'
import $ from 'jquery'
export default {
  props: ['dialog'],
  data () {
    return {
      label: '',
      qrs: [],
      page: 1,
      totalPages: 0,
      totalElements: 0
    }
  },
  components: {
    qrItem
  },
  mounted () {
    let label = ''
    if (this.$route.params.id === 'all' || this.$route.params.id === 'NaN') {
      label = ''
    } else {
      label = parseInt(this.$route.params.id)
    }
    let num = parseInt(this.$route.params.num)
    let page = parseInt(this.$route.params.page)
    this.fetchData(label, num, page)
  },
  methods: {
    handleCurrentChange (val) {
      this.$router.push('/analysis/scan/labelid/' + parseInt(this.$route.params.id) + '/n/5' + '/p/' + val)
    },
    fetchData: function (label, num, page) {
      const vm = this
      $.ajax({
        type: 'GET',
        url: '/v1/user/qrs',
        data: {
          l: label,
          n: num,
          p: page
        },
        dataType: 'json',
        success: function (response) {
          vm.qrs = response.data.content
          vm.page = response.data.number + 1
          vm.totalPages = response.data.totalPages
          vm.totalElements = response.data.totalElements
        }
      })
    },
    clickQr (val) {
      // this.$message.info(this.dialog.selectedQrId)
      this.dialog.selectedQrId = val.qrid
      this.dialog.selectQrButtonText = val.qrname === '' ? '未命名' : val.qrname
      this.dialog.seen = false
    }
  },
  beforeRouteUpdate (to, from, next) {
    let label = ''
    if (to.params.id === 'all' || to.params.id === 'NaN') {
      label = ''
    } else {
      label = parseInt(to.params.id)
    }
    let num = parseInt(to.params.num)
    let page = parseInt(to.params.page)
    this.fetchData(label, num, page)
    next()
  }
}
</script>
